import { render } from "./LoaderButton.vue?vue&type=template&id=2f9d6692&ts=true"
import script from "./LoaderButton.vue?vue&type=script&lang=ts"
export * from "./LoaderButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__